import type { Variant } from '../gameTypes.js';
import type { PianoChart } from '../pianoChart.js';
import { PALETTE_TOXIC } from '../builtinPulseMaps/palettes.js';
import { buildBuiltinAudio } from '../builtinPulseMaps/audioFromOnsets.js';
import audioOnsets from '../circlesBuiltinMaps/audio/nekozilla.onsets.json' with { type: 'json' };
import { pianoVariantsFromSpec } from './pianoFromOnsets.js';

/**
 * Nekozilla — Different Heaven (NCS). 128 BPM heavy electro with
 * relentless kicks across the full song. Top-tier challenge — the
 * sustained density tests stamina more than reading.
 *
 * Synthesised from the Circles onset analysis. See the header doc
 * on {@link import('./01-on-and-on.js').ON_AND_ON_PIANO_VARIANTS}
 * for the curated-MIDI upgrade path.
 */
export const NEKOZILLA_PIANO_VARIANTS: Record<Variant, PianoChart> = pianoVariantsFromSpec({
  baseSlug: 'nekozilla',
  baseTitle: 'Nekozilla',
  description:
    "Different Heaven's heavy 128 BPM electro. Relentless kicks across the full song test stamina more than reading.",
  difficulty: 5,
  totalBeats: 131,
  palette: PALETTE_TOXIC,
  audio: buildBuiltinAudio({
    src: '/audio/circles/nekozilla.mp3',
    attribution: '"Nekozilla" by Different Heaven [NCS Release] - https://ncs.io/Nekozilla',
    data: audioOnsets,
  }),
  onsets: audioOnsets,
  sections: [
    {
      startBeat: 0,
      endBeat: 131,
      selectOpts: { kinds: ['lead', 'snare'], minIntensity: 0.07, minSpacing: 0.5 },
    },
  ],
});
